'use strict';

CompanyAddContactsCtrl.$inject = [
  '$scope',
  '$stateParams',
  'contacts',
  'CompanyAddressBookService'];
function CompanyAddContactsCtrl(
  $scope,
  $stateParams,
  contacts,
  CompanyAddressBookService) {
  var nonContactsAddedPromise = contacts;
  if($scope.projectEdit && $scope.projectEdit.contacts.length){
    nonContactsAddedPromise = contacts.filter(function(v) {
      return !$scope.projectEdit.contacts.some(function (u) {
        return v.id === u.id;
      });
    });
  }
  $scope.nonContactsAdded = nonContactsAddedPromise;

  $scope.newContact = {
    contactName: "",
    contactPhone: "",
    contactEmail: "",
    contactWeb: ""
  };

  $scope.changeNewContact = function(contact){
    if($scope.newContact && $scope.newContact.id && $scope.newContact.id === contact.id){
      $scope.newContact = {
        contactName: "",
        contactPhone: "",
        contactEmail: "",
        contactWeb: ""
      };
      angular.forEach($scope.nonContactsAdded, function(c){
        c.selected = false;
      });
    }else{
      $scope.newContact = contact;
      angular.forEach($scope.nonContactsAdded, function(c){
        if(c.id === $scope.newContact.id){
          c.selected = true;
        }else{
          c.selected = false;
        }
      });
    }
  };

  $scope.saveContact = function(contact) {
    if(!contact.id){
      CompanyAddressBookService.save({companyId: $stateParams.companyId}, contact).$promise.then(function(resp){
        $scope.nonContactsAdded.push(resp);
        $scope.newContact = {
          contactName: "",
          contactPhone: "",
          contactEmail: "",
          contactWeb: ""
        };
      });
    }else{
      CompanyAddressBookService.update({companyId: $stateParams.companyId, contactId: contact.id}, contact);
    }
  };

  $scope.queryContacts = function(filter) {
    CompanyAddressBookService.query({companyId: $stateParams.companyId, limit: 20, q: filter}).$promise.then(function(resp){
      $scope.nonContactsAdded = resp;
    });
  };

  $scope.addCustomerContacts = function() {
    if($scope.newContact.id){
      if($scope.projectEdit && $scope.projectEdit.contacts){
        $scope.projectEdit.contacts.push($scope.newContact);
        $scope.newContact = {
          contactName: "",
          contactPhone: "",
          contactEmail: "",
          contactWeb: ""
        };
      }else{
        $scope.addContact($scope.newContact);
      }
    }
  };

  $scope.removeContact = function(contact) {
    if(contact.id){
      CompanyAddressBookService.delete({companyId: $stateParams.companyId, contactId: contact.id}).$promise.then(function(){
        $scope.nonContactsAdded.splice($scope.nonContactsAdded.indexOf(contact), 1);
        $scope.newContact = {
          contactName: "",
          contactPhone: "",
          contactEmail: "",
          contactWeb: ""
        };
      });
    }
  };

}

angular.module('dokiv')
  .controller('CompanyAddContactsCtrl', CompanyAddContactsCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/projects/CompanyAddContactsCtrl.js
// module id = 369
// module chunks = 0